import { http } from '../index';

export const getActions = () => {
  return http.get('/action-management/v1/actions').then(({ data }) => data);
};
